import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { MatTabChangeEvent, MatTabGroup } from '@angular/material/tabs';
import { MessageService } from '../../message.service';
import { Conversation } from '../../../reservation/reservation.model';

export interface Tab {
	name: string;
	textLabel: string;
}

@Component({
	selector: 'app-message-tabs',
	templateUrl: './message-tabs.component.html',
	styleUrls: ['./message-tabs.component.scss'],
})
export class MessageTabsComponent implements AfterViewInit {
	protected tabs: Tab[] = [
		{ name: 'category:First', textLabel: 'Sprzedaż' },
		{ name: 'category:Second', textLabel: 'Organizacja' },
	];
	@ViewChild(MatTabGroup) tabGroup: MatTabGroup;
	@ViewChild('messageTableRef') messageTable: any;
	tableRendered = false;
	constructor(protected service: MessageService) {}

	//TODO: waiting for category filter
	onTabChanged(event: MatTabChangeEvent) {
		console.log(event);
	}

	ngAfterViewInit() {
		// This is solution for NG0100: Expression has changed after it was checked
		setTimeout(() => {
			this.tableRendered = true;
		}, 0);
	}

	protected isAllArchived(): boolean {
		if (this.messageTable) {
			return this.messageTable.cachedThreads.every((thread: Conversation) => {
				return this.messageTable.isArchived(thread);
			});
		}

		return false;
	}

	protected archiveThreads() {
		this.messageTable.archiveThreads();
	}

	protected watchThreads() {
		this.messageTable.watchThreads();
	}

	protected openAssignReservationDialog() {
		this.messageTable.openAssignReservationDialogForSelectedThreads();
	}

	protected openAssignUserDialog() {
		this.messageTable.openAssignUserDialogForSelectedThreads();
	}
}
